import type { LayoutRegion, PageLayout, TextBlock } from "../types";

export interface TranslationPageSections {
  top: LayoutRegion[];
  columns: LayoutRegion[];
  bottom: LayoutRegion[];
}

export const MIN_TRANSLATION_FONT_SIZE = 10;

export function translationFontSize(
  block: Pick<TextBlock, "fontSize" | "role">,
  zoom: number
): number {
  const roleScale =
    block.role === "title" ? 1.35 : block.role === "heading" ? 1.15 : 1;
  const preferred = Math.min(20, Math.max(11.5, block.fontSize * roleScale));
  return Math.max(MIN_TRANSLATION_FONT_SIZE, preferred * zoom);
}

export function splitTranslationRegions(
  page: Pick<PageLayout, "regions">
): TranslationPageSections {
  const ordered = [...page.regions].sort((a, b) => a.order - b.order);
  const columns = ordered.filter((region) => region.kind === "column");
  if (!columns.length) {
    return { top: ordered, columns: [], bottom: [] };
  }

  const firstColumnOrder = Math.min(...columns.map((region) => region.order));
  const lastColumnOrder = Math.max(...columns.map((region) => region.order));
  return {
    top: ordered.filter(
      (region) =>
        region.kind === "full-width" && region.order < firstColumnOrder
    ),
    columns: columns.sort(
      (a, b) => a.columnIndex - b.columnIndex || a.order - b.order
    ),
    bottom: ordered.filter(
      (region) =>
        region.kind === "full-width" && region.order > lastColumnOrder
    )
  };
}

export function blocksInRegion(
  page: Pick<PageLayout, "blocks">,
  regionId: string
): TextBlock[] {
  return page.blocks
    .filter((block) => block.regionId === regionId && block.translatable)
    .sort((a, b) => a.order - b.order);
}
